<template>
  <div ref="chartDom" class="echarts-container"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "BaseECharts",
  props: {
    option: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  watch: {
    option: {
      handler(newVal) {
        if (this.chartInstance) {
          this.chartInstance.setOption(newVal, true);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chartDom) return;

      // 销毁旧实例（避免重复初始化）
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }

      // 创建新实例
      this.chartInstance = echarts.init(this.$refs.chartDom, null, {
        renderer: "svg",
        useDirtyRect: true,
      });

      // 设置图表配置
      this.chartInstance.setOption(this.option);
    },
    resizeHandler() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
  },
};
</script>

<style scoped>
.echarts-container {
  width: 100%;
  height: 100%;
}
</style>